import api from '@api/api';
import { CommonResponseObj } from '@models/common';
import { LoginInfo } from '@models/user';
import { unwrapResult } from '@reduxjs/toolkit';
import { AppDispatch } from '@store/index';
import { fetchPermissionList } from '@store/reducers/permissionSlice';
import { logIn, logOut } from '@store/reducers/userSlice';

async function getArea() {
  // get area list
  const res = await api.post('/api/config-service/area/getArea');
  const { code, msg, data }: CommonResponseObj = res.data;

  if (code !== 0) {
    throw new Error(msg);
  }

  return data;
}

function handleLoginAndSetup(credentials: LoginInfo) {
  return async function asyncThunkFunction(dispatch: AppDispatch) {
    let isLoggedIn = false;
    try {
      const logInAction = await dispatch(logIn(credentials));
      unwrapResult(logInAction);
      // 若到了這步則代表登入成功
      isLoggedIn = true;

      const permissionAction = await dispatch(fetchPermissionList());
      unwrapResult(permissionAction); // Unwrap fetchPermissionList result

      const areaData = await getArea();
      localStorage.setItem('areaData', JSON.stringify(areaData));
    } catch (err: any) {
      // 如果先前已經登入成功，但在取得權限時發生錯誤，則登出
      // 如果登入過程中就失敗，則無須進行登出，以避免畫面被重新整理，也能讓登入頁面保存使用者輸入的資訊
      if (isLoggedIn) await dispatch(logOut());

      console.warn('Error encountered in handleLoginAndSetup', err);
      throw new Error(err.message);
    }
  };
}

export default handleLoginAndSetup;
